import store from '@/store'

class WebSocketService {
  constructor() {
    this.socket = null;
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 5;
  }

  connect(token) {
    if (this.socket) return;
    
    try {
      const wsProtocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
      this.socket = new WebSocket(`${wsProtocol}://${process.env.VUE_APP_HOST}/ws/notifications/?token=${token}`);

      this.socket.onmessage = (event) => {
        try {
          const notification = JSON.parse(event.data);
          console.log('Received notification:', notification);
          // Handle the notification
          this.handleNotification(notification);
        } catch (error) {
          console.error('Error parsing notification:', error);
        }
      };
    } catch (error) {
      console.error('WebSocket connection failed:', error);
    }
  }

  handleNotification(notification) {
    // Dispatch directly to store (alternative approach)
    if (store) {
      store.dispatch('Notifications/addNotification', {
        id: notification.id,
        read: notification.read || false,
        title: notification.title,
        body: notification.body,
        message: notification.message,
        action_url: notification.action_url || null,
        timestamp: new Date().toISOString()
      });
    }
    
    // Show browser notification
    if (Notification.permission === 'granted') {
      this.playNotificationSound()
      this.updateFavicon(true)
    } else if (Notification.permission !== 'denied') {
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          this.playNotificationSound()
          this.updateFavicon(true)
        }
      });
    }

  }

  playNotificationSound() {
    const audio = new Audio('/sounds/beyond-doubt-580.mp3');
    audio.play().catch(err => console.warn('Audio play failed:', err));
  }

  updateFavicon(hasNotification) {
    const link = document.querySelector("link[rel~='icon']");
    if (!link) return;

    link.href = hasNotification ? "/favicon-notify.png" : "/favicon.png";
  }

  disconnect() {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
  }
}

export default new WebSocketService();